import { useCopy } from "../i18n";

const Half = ({ items, hidden }) => (
  <div className="flex items-center gap-10 pr-10" aria-hidden={hidden || undefined}>
    {items.map((item) => (
      <span key={item} className="flex items-center gap-10">
        <span className="whitespace-nowrap font-serif-display text-2xl italic text-[#1E2A38]/80">{item}</span>
        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-[#B89762]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const copy = useCopy();
  return (
    <section
      data-testid="keyword-marquee"
      aria-label="Aree di competenza"
      className="overflow-hidden border-y border-[rgba(18,19,22,0.08)] bg-[#F4F3EF] py-6"
    >
      <div className="marquee-track flex w-max">
        <Half items={copy.marquee} hidden={false} />
        <Half items={copy.marquee} hidden={true} />
      </div>
    </section>
  );
};

export default Marquee;
